import axios from "../axios/axios";
import { setBusiness, setBusinesses } from "../store/actions/businessAction";
import { appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { appSetLoading } from "../store/actions/appAction";
import { errorDispatcher, resetAppData } from "../helpers";
import { convertToBusinessUpdateFormat } from "helpers/dataFormat";

export const apiGetBusiness = (business, token, callback, offline) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`dashboard?businessId=${business.id}${offline ? '&offline=true' : ''}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(async (response) => {
      const busToken = response.data.token
      const User_Accesses = await axios.get("dashboard/userAccess", {
        headers: { Authorization: `Bearer ${busToken}` }
      })
      const businessAccess = await axios.get('businesses/subscription/limitation', {
        headers: { Authorization: `Bearer ${busToken}` },
      })
      const fiscalYear = await axios.get('dashboard/fiscalYear', {
        headers: { Authorization: `Bearer ${busToken}` },
      })
      const businessData = {
        business: {
          ...business,
          userRole: User_Accesses.data.userRole,
          ...User_Accesses.data.businessSettings,
          subscription:
            response.data.business.Business_Subscription_Prices[0]?.Subscription_Price?.Subscription,
          offlineConfig: response.data.business.offlineConfig,
          ...response.data.business
        },
        token: response.data.token,
        fiscalYearTitle: fiscalYear.data.data.name,
        fiscalYearStartDate: fiscalYear.data.data.start_date,
        fiscalYeaEndDate: fiscalYear.data.data.end_date,
        user: { ...response.data.user, User_Accesses: User_Accesses.data.User_Accesses, businessAccess: businessAccess.data.businessLimit },
      };
      dispatch(setBusiness(businessData));
      dispatch(appSetLoading(false));

      if (callback) {
        callback(response.data);
      }
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetBusinesses = (token, navigate, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get("businesses", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const businesses = response.data.businesses.Businesses;
      dispatch(setBusinesses(businesses));
      dispatch(appSetLoading(false));

      if (callback) {
        callback();
      }

      if (businesses.length === 0) {
        navigate("/business");
        // navigate("/setupBusiness");
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        dispatch(apiSetAlert("اطلاعات حساب معتبر نیست، مجددا وارد شوید", "error", false));
        resetAppData(dispatch);
        navigate("/auth/login");
      } else {
        errorDispatcher(error, dispatch);
      }
    });
};

export const apiDeleteBusiness = (businessId, token, dispatch, navigate) => {
  dispatch(appSetLoading());
  axios
    .delete("/businesses", {
      headers: { Authorization: `Bearer ${token}` },
      data: {
        businessId: businessId,
      },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      dispatch(apiGetBusinesses(token, navigate));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiLeaveBusiness = (businessId, token, dispatch, navigate) => {
  dispatch(appSetLoading());
  axios
    .post(
      "/businesses",
      { businessId },
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { leave: true },
      }
    )
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      dispatch(apiGetBusinesses(token, navigate));
      navigate("/");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiCheckBusiness = (token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get("/businesses/checkOut", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiAddBusinesses = (inputs, token, navigate) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .post("/businesses", inputs, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      navigate("/");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiUpdateBussiness = (form, token) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  const formated = convertToBusinessUpdateFormat(form);
  axios
    .put("/businesses", formated, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      dispatch(apiGetBusiness(form, token, undefined, true));
      dispatch(appSetSendingRequest(false));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
      dispatch(appSetLoading(false));
    });
};
